'use client'
import React from 'react'
import CommunitiesList from '../list/communities-list'
import { useQuery } from '@tanstack/react-query'
import { useIpLocationStore } from 'store/server-context/ip-location'
import { exploreCommunityPageV2 } from 'api/search'
import { clientFetch } from 'lib/fetch/client'
import { useLocale } from 'next-intl'
import { useSessionStore } from 'store/server-context/session'

const TrendingCommunity = () => {
  const locale = useLocale()
  const session = useSessionStore(state => state.session)
  const ipLocation = useIpLocationStore(state => state.ipLocation)
  const SIZE = 30

  const { data, isLoading } = useQuery({
    queryKey: ['search'],
    queryFn: async () => {
      const { ip_geo_point } = ipLocation || {
        ip_geo_point: {
          lat: 0,
          lng: 0
        }
      }

      const { communities } = await exploreCommunityPageV2(clientFetch, {
        user_coordinate: {
          lat: ip_geo_point.lat.toString(),
          lng: ip_geo_point.lng.toString()
        },
        language: locale,
        user_id: session.user_id,
        size: SIZE
      })
      return communities
    }
  })

  return (
    <div className='px-[16px]'>
      <CommunitiesList
        communities={data || []}
        loading={isLoading}
        LoadingCount={10}
        viewBoxValue='0 0 500 700'
      />
    </div>
  )
}

export default TrendingCommunity
